import { createStyles, makeStyles } from "@mui/styles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    tooltip: {
      background: theme.white50,
      borderRadius: "8px",
      boxShadow: "2px 4px 16px rgba(0, 0, 0, 0.2)",
      padding: theme.spacing(9, 8),
    },
    boldText: {
      fontWeight: "bold",
      marginLeft: theme.spacing(2),
    },
    alignCenter: {
      alignItems: "center",
      display: "flex",
    },
  }),
);
